/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetSpaceRequest} from '@cash-web/protos/squareup/cash/cashfrontdoor/api/v1beta1/space_messages.pb'
import {GetSpaceResponse} from '@cash-web/protos/squareup/cash/cashfrontdoor/api/v1beta1/space_messages.pb'


export const getSpace = (request: GetSpaceRequest, options?: CashRequestOptions) => post<GetSpaceRequest, GetSpaceResponse>("/cash-app/frontdoor/get-space", request, {...options, rejectOnError: true })